import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, mergeMap } from 'rxjs/operators';
import { AppStore } from 'src/app/store/store.model';
import { isUserLoaded, selectUserHighestRole } from 'src/app/store/user/user.selectors';
import { OrganizationRoleTypes } from '../store/user/user.enum';

@Injectable({
  providedIn: 'root',
})
export class UserRoleGuard {
  constructor(private router: Router, private store: Store<AppStore>) {}

  public canActivate(route: ActivatedRouteSnapshot) {
    const disallowedRoles = route.data.disallowedRoles as OrganizationRoleTypes[];

    return this.store.select(isUserLoaded).pipe(
      filter(Boolean),
      mergeMap(() => this.store.select(selectUserHighestRole)),
      map((userRole) => {
        if (disallowedRoles.includes(userRole)) {
          this.router.navigate(['/dashboard']);
          return false;
        }

        return true;
      }),
    );
  }
}
